/*企业查询*/
import axios from "@/api/enterprise_system";

let method = 'GET';
/**-----------------------------------------------------------------开庭公告-----------------------------------------------------------*/
/*获取当前公司价值评估统计*/
export const getEvaluationStatistics = data => axios.post('/bqw/enterpriseValue/getEvaluationStatistics', data)
/*搜索开庭公告*/
export const searchCourtNotice = data => axios.post('/bqw/courtNotice/searchCourtNotice', data)
/*开庭公告地域分组*/
export const getRegion = data => axios.get('/bqw/courtNotice/getRegion', data)
/*信息类型分组*/
export const getAnnouncementType = data => axios.get('/bqw/bidding/getAnnouncementType', data)
/*地域分组*/
export const getRegionGroup = data => axios.get('/bqw/bidding/getRegionGroup', data)
/*发布日期分组*/
export const getPublicationDate = data => axios.get('/bqw/bidding/getPublicationDate', data)

/**——————————————————————————————————————----------------------------招投标------------------------------------------------------------*/
/*搜索招投标*/
export const searchBiddingByKeyword = data => axios.post('/bqw/bidding/searchBiddingByKeyword', data)
/*招投标详情*/
export const getBiddingDetails = data => axios.post('/bqw/bidding/getBiddingDetails', data)
/**------------------------------------------------------------------法院公告-----------------------------------------------------------*/
/*搜索法院公告*/
export const searchDdCourtDeclared = data => axios.post('/bqw/courtDeclared/searchDdCourtDeclared', data)

/**------------------------------------------------------------------被执行人-----------------------------------------------------------*/
/*被执行人地域分组*/
export const getExecutorRegion = data => axios.get('/bqw/executedPerson/getRegion', data)
/*搜索被执行人*/
export const searchDdExecutedPerson = data => axios.post('/bqw/executedPerson/searchDdExecutedPerson', data)

/**------------------------------------------------------------------行政处罚-----------------------------------------------------------*/
/*处罚机关分组*/
export const getDecisionOffice = data => axios.get('/bqw/administrativeSanction/getDecisionOffice', data)
/*行政处罚详情*/
export const getAdministrativeSanctionDetails = data => axios.get('/bqw/administrativeSanction/getDetails', data)
/*行政处罚列表*/
export const searchDdAdministrativeSanction = data => axios.post('/bqw/administrativeSanction/searchDdAdministrativeSanction', data)
/*处罚种类分组*/
export const getIllegalActivitiesType = data => axios.get('/bqw/administrativeSanction/getIllegalActivitiesType', data)
/*执法地域分组*/
export const getLawEnforcementRegionByGroup = data => axios.get('/bqw/administrativeSanction/getLawEnforcementRegionByGroup', data)
/*处罚年份分组*/
export const getPunishDecisionDate = data => axios.get('/bqw/administrativeSanction/getPunishDecisionDate', data)

/**------------------------------------------------------------------裁判文书-------------------------------------------------------------*/
/*案由分类*/
export const LegalProceedingsclassification = data => axios.get('/bqw/legalProceedings/LegalProceedingsclassification', data)
/*案件类型/审理进程/文书类型*/
export const getCaseScreen = data => axios.get('/bqw/legalProceedings/getCaseScreen', data)
/*搜索所有诉讼*/
export const getLegalProceedingsBySummary = data => axios.post('/bqw/legalProceedings/getLegalProceedingsBySummary', data)
/*获取诉讼详情*/
export const getLegalProceedingsDateilsByid = data => axios.post('/bqw/legalProceedings/getLegalProceedingsDateilsByid', data)

/**------------------------------------------------------------------进出口信用------------------------------------------------------------*/
/*搜索公司的进出口信用*/
export const getImportExportCreditByCid = data => axios.post('/bqw/importExportCredit/getImportExportCreditByCid', data)

/**-------------------------------------------------------------------司法拍卖-------------------------------------------------------------*/
/*司法拍卖地域分布*/
export const getJudicialAuctionRegionGroup = data => axios.get('/bqw/judicialAuction/getJudicialAuctionRegionGroup', data)
/*搜索司法拍卖*/
export const getJudicialAuctionByCid = data => axios.post('/bqw/judicialAuction/getJudicialAuctionByCid', data)
/*司法拍卖id获取详情*/
export const getJudicialAuctionDetails = data => axios.post('/bqw/judicialAuction/getJudicialAuctionDetails', data)

/**-------------------------------------------------------------------上市公司--------------------------------------------------------------*/
/*交易所列表*/
export const exchangeList = data => axios.get('/bqw/addBusinessQuery/exchangeList', data)
/*上市公司列表*/
export const listedCompanyList = data => axios.post('/bqw/addBusinessQuery/listedCompanyList', data)

/*获取行业分类*/
export const getIndustry = data => axios.get('/bqw/industry/getIndustry', data)
/*融资事件列表*/
export const financingEventsList = data => axios.post('/bqw/addBusinessQuery/financingEventsList', data)
/*投资机构列表*/
export const investmentAgencyList = data => axios.post('/bqw/addBusinessQuery/investmentAgencyList', data)
/*债券列表*/
export const bondList = data => axios.post('/bqw/addBusinessQuery/bondList', data)
/*产业园区列表*/
export const industrialParksList = data => axios.post('/bqw/addBusinessQuery/industrialParksList', data)
/*产业链列表*/
export const industrialChainList = data => axios.get('/bqw/addBusinessQuery/industrialChainList', data)
/*产业链子分类下企业列表*/
export const industrialChainCompanyList = data => axios.post('/bqw/addBusinessQuery/industrialChainCompanyList', data)
/*科技型企业分类*/
export const technologyEnterprise = data => axios.get('/bqw/addBusinessQuery/technologyEnterprise', data)
/*企业状态*/
export const getEnterpriseStatus = data => axios.get('/bqw/addBusinessQuery/enterpriseStatus', data)
/*查询新增企业列表*/
export const newBusinessList = data => axios.post('/bqw/addBusinessQuery/newBusinessList', data)
/*科技型企业列表*/
export const technologyEnterpriseCompanyList = data => axios.post('/bqw/addBusinessQuery/technologyEnterpriseCompanyList', data)
/*科技型企业注册资本*/
export const technologyEnterCapital=data=>axios.get('/bqw/addBusinessQuery/technologyEnterCapital',data)
/*科技型企业成立年限*/
export const technologyEstYear=data=>axios.get('/bqw/addBusinessQuery/technologyEstYear',data)
/*搜索税务评级*/
export const creditRating=data=>axios.post('/bqw/taxRating/searchTaxRating',data)
/*信用级别*/
export const getCreditRating=data=>axios.get('/bqw/taxRating/getCreditRating',data)
/*地域分组*/
export const getTaxRatingRegion=data=>axios.get('/bqw/taxRating/getTaxRatingRegion',data)
export const newPcSearchCompany=data=>axios.post('/bqw/company/newPcSearchCompany',data)
/*高级查询--搜索公司*/
export const searchCompany=data=>axios.post('/bqw/newCompanyInfoController/searchCompany',data)
